// extracted by mini-css-extract-plugin
module.exports = {"headerText":"Header_headerText__3vU8u","headerContent":"Header_headerContent__SRCKR","headerIntroD":"Header_headerIntroD__2xUx9","headerIntroM":"Header_headerIntroM__3kiqr"};